export default __webpack_public_path__ + "static/media/cross_mark.64999434.svg";